import { render, staticRenderFns } from "./region-selection-modal.vue?vue&type=template&id=6858b376&"
import script from "./region-selection-modal.vue?vue&type=script&lang=js&"
export * from "./region-selection-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports